export { Terminal as default } from './Terminal';
